import React, { Component, useEffect, useState, CSSProperties } from 'react'
import functions from '../utils/functions'
import { Link, useHistory } from 'react-router-dom';
import $ from 'jquery'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ajax from '../utils/ajax';


const SlidersHome = (props) => {


    const [mostClickList, setMostClickList] = useState(false);
    const [userId, setUserId] = useState(functions.sessionGuard())
    const nav = useHistory();


    const settings = {
        dots: true,
        speed: 1000,
        autoplaySpeed: 5000,
        autoplay: true,
        infinite: true,
        slidesToShow: mostClickList.length < 4 ? 2 : 4,
        pauseOnHover: true,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows:false,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: mostClickList.length < 3 ? 2 : 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },


            {
                breakpoint: 600,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 576,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 540,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 992,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                    centerMode: false,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div>

            <div class="case-slider-area" >

                {/* <h1>gdafafadf</h1> */}

                <Slider {...settings}>

                    <div class="case-boxarea">
                        <div class="img1">
                            <img src="assets/img/all-images/case/case19.png" alt="" />
                        </div>
                        <div class="content-area">
                            {/* <a href="#" class="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                <path d="M7 21L21 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.625 7H21V18.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg></a> */}
                            <div class="space24"></div>
                            {/* <a href="case-right.html" class="tags">Cardiologist</a> */}
                            <div class="space18"></div>
                            <a href="#" class="title">Fracture Success Stories</a>
                        </div>
                    </div>

                    <div class="case-boxarea">
                        <div class="img1">
                            <img src="assets/img/all-images/case/case18.png" alt="" />
                        </div>
                        <div class="content-area">
                            {/* <a href="#" class="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                <path d="M7 21L21 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.625 7H21V18.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg></a> */}
                            <div class="space24"></div>
                            {/* <a href="#" class="tags">Cardiologist</a> */}
                            <div class="space18"></div>
                            <a href="#" class="title">Back Pain Success Stories</a>
                        </div>
                    </div>

                    <div class="case-boxarea">
                        <div class="img1">
                            <img src="assets/img/all-images/case/case17.png" alt="" />
                        </div>
                        <div class="content-area">
                            {/* <a href="#" class="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                <path d="M7 21L21 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.625 7H21V18.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg></a> */}
                            <div class="space24"></div>
                            {/* <a href="#" class="tags">Cardiologist</a> */}
                            <div class="space18"></div>
                            <a href="#" class="title">Dislocation Success Stories</a>
                        </div>
                    </div>

                    <div class="case-boxarea">
                        <div class="img1">
                            <img src="assets/img/all-images/case/case16.png" alt="" />
                        </div>
                        <div class="content-area">
                            {/* <a href="#" class="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                <path d="M7 21L21 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.625 7H21V18.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg></a> */}
                            <div class="space24"></div>
                            {/* <a href="#" class="tags">Cardiologist</a> */}
                            <div class="space18"></div>
                            <a href="#" class="title">Similations</a>
                        </div>
                    </div>

                    <div class="case-boxarea">
                        <div class="img1">
                            <img src="assets/img/all-images/case/case15.png" alt="" />
                        </div>
                        <div class="content-area">
                            {/* <a href="#" class="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                <path d="M7 21L21 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.625 7H21V18.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg></a> */}
                            <div class="space24"></div>
                            {/* <a href="#" class="tags">Cardiologist</a> */}
                            <div class="space18"></div>
                            <a href="#" class="title">Routine Checks </a>
                        </div>
                    </div>

                    <div class="case-boxarea">
                        <div class="img1">
                            <img src="assets/img/all-images/case/case14.png" alt="" />
                        </div>
                        <div class="content-area">
                            {/* <a href="#" class="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                <path d="M7 21L21 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.625 7H21V18.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg></a> */}
                            <div class="space24"></div>
                            {/* <a href="#" class="tags">Cardiologist</a> */}
                            <div class="space18"></div>
                            <a href="#" class="title">Rehabilitation Success Stories</a>
                        </div>
                    </div>

                    <div class="case-boxarea">
                        <div class="img1">
                            <img src="assets/img/all-images/case/case13.png" alt="" />
                        </div>
                        <div class="content-area">
                            <a href="#" class="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                <path d="M7 21L21 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.625 7H21V18.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg></a>
                            <div class="space24"></div>
                            {/* <a href="#" class="tags">Cardiologist</a> */}
                            <div class="space18"></div>
                            <a href="#" class="title">Knee Success Stories</a>
                        </div>
                    </div>

                    <div class="case-boxarea">
                        <div class="img1">
                            <img src="assets/img/all-images/case/case20.png" alt="" />
                        </div>
                        <div class="content-area">
                            {/* <a href="#" class="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                <path d="M7 21L21 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.625 7H21V18.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg></a> */}
                            <div class="space24"></div>
                            {/* <a href="#" class="tags">Cardiologist</a> */}
                            <div class="space18"></div>
                            <a href="#" class="title">Sports Success Stories</a>
                        </div>
                    </div>

                    <div class="case-boxarea">
                        <div class="img1">
                            <img src="assets/img/all-images/case/case22.png" alt="" />
                        </div>
                        <div class="content-area">
                            {/* <a href="#" class="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                <path d="M7 21L21 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.625 7H21V18.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg></a> */}
                            <div class="space24"></div>
                            {/* <a href="#" class="tags">Cardiologist</a> */}
                            <div class="space18"></div>
                            <a href="#" class="title">Fracture Success Stories</a>
                        </div>
                    </div>

                </Slider>
            </div>

        </div>
    )
}
export default SlidersHome